/** Keep in sync with backend/Helper/emailAssets.js */
export const BRAND_SOCIAL_ICONS = {
  logo: "https://res.cloudinary.com/dzpdqcmxv/image/upload/v1780216639/logoo_l6962e.png",
  twitter:
    "https://res.cloudinary.com/dzpdqcmxv/image/upload/v1780216568/1770720552777-twitter_tzaqjo.png",
  facebook:
    "https://res.cloudinary.com/dzpdqcmxv/image/upload/v1780216629/facebook_lsfwak.png",
  linkedin:
    "https://res.cloudinary.com/dzpdqcmxv/image/upload/v1780216568/1770720552776-linkdin_zkllge.png",
  telegram:
    "https://res.cloudinary.com/dzpdqcmxv/image/upload/v1780216568/1770720552777-telegrem_jlsmqw.png",
  skype:
    "https://res.cloudinary.com/dzpdqcmxv/image/upload/v1780216568/1770720552777-skype_t1rupv.png",
};

export const BRAND_STATIC_FILES = {
  headerBg: "headerbg.png",
  banner: "banner.png",
};

export const buildPublicAssetUrl = (baseUrl, filename) => {
  const base = (baseUrl || "").replace(/\/+$/, "");
  if (!base || !filename) return "";
  return `${base}/public/settings/${filename}`;
};

export const resolveBrandImageUrl = (customUrl, fallback = "") => {
  const url = String(customUrl || "").trim();
  if (url && /^https?:\/\//i.test(url)) return url;
  return fallback || "";
};

export const getBrandAssetsFromSettings = (settings, apiUrl) => {
  const asset = (file) => buildPublicAssetUrl(apiUrl, file);
  const s = settings || {};
  const legacy = (filename, fallback) =>
    filename ? asset(filename) : fallback;

  return {
    logo: resolveBrandImageUrl(
      s.emailLogoUrl,
      legacy(s.sitelogo, BRAND_SOCIAL_ICONS.logo)
    ),
    twitter: resolveBrandImageUrl(
      s.emailTwitterIconUrl,
      legacy(s.twitterIcon, BRAND_SOCIAL_ICONS.twitter)
    ),
    facebook: resolveBrandImageUrl(
      s.emailFacebookIconUrl,
      legacy(s.facebookIcon, BRAND_SOCIAL_ICONS.facebook)
    ),
    linkedin: resolveBrandImageUrl(
      s.emailLinkedinIconUrl,
      legacy(s.linkedinIcon, BRAND_SOCIAL_ICONS.linkedin)
    ),
    telegram: resolveBrandImageUrl(
      s.emailTelegramIconUrl,
      legacy(s.telegramIcon, BRAND_SOCIAL_ICONS.telegram)
    ),
    skype: resolveBrandImageUrl(
      s.emailSkypeIconUrl,
      legacy(s.skypeIcon, BRAND_SOCIAL_ICONS.skype)
    ),
    headerBg: resolveBrandImageUrl(
      s.emailHeaderBgUrl,
      asset(BRAND_STATIC_FILES.headerBg)
    ),
    banner: resolveBrandImageUrl(
      s.emailBannerUrl,
      asset(BRAND_STATIC_FILES.banner)
    ),
  };
};

export const FOOTER_SOCIAL_LINKS = [
  { linkKey: "facebookLink", iconKey: "facebook", label: "Facebook" },
  { linkKey: "linkedinLink", iconKey: "linkedin", label: "LinkedIn" },
  { linkKey: "twitterLink", iconKey: "twitter", label: "Twitter" },
  { linkKey: "telegramLink", iconKey: "telegram", label: "Telegram" },
  { linkKey: "skypeLink", iconKey: "skype", label: "Skype" },
];
